<script setup lang="ts">
import AbroadHero from '@/domains/about/company/abroad/components/Hero/Hero.vue'
import AbroadCountry from '@/domains/about/company/abroad/components/Country/Country.vue'
import AbroadFlag from '@/domains/about/company/abroad/components/Flag/Flag.vue'
import AbroadAboutCompany from '@/domains/about/company/abroad/components/AboutCompany/AboutCompany.vue'
import AbroadContact  from '@/domains/about/company/abroad/components/Contact/Contact.vue'

</script>
<template>
  <AbroadHero />

  <AbroadCountry />

  <AbroadFlag />

  <AbroadAboutCompany />

  <AbroadContact />

</template>